import {
  IonCard,
  IonCol,
  IonGrid,
  IonIcon,
  IonLabel,
  IonRow,
} from "@ionic/react";
import {
  addCircle,
  easelOutline,
  removeCircle,
  trashOutline,
} from "ionicons/icons";
import { useCart } from "./useCart";
import { NumberMoney } from "../../components/NumberMoney/NumberMoney";
import SubHeader from "../FrameAndEasel/SubHeader";
import { usePictures } from "../Pictures/usePictures";

const EaselWood = () => {
  const { easelWood, changeEaselWoodNumber } = useCart();

  const { equipmentPrice, equipmentState } = usePictures();
  const disabled = !equipmentState.easelW;

  return (
    <IonCard style={{ margin: "3px", padding: "13px 16px 0 16px" }}>
      <SubHeader
        icon={easelOutline}
        text="Drveni štafelaj"
        onTop
        disabled={disabled}
      >
        <NumberMoney value={equipmentPrice.easelW} />
      </SubHeader>
      <br />

      {!disabled && (
        <IonGrid>
          <IonRow>
            <IonCol className="ion-text-right">
              {easelWood > 0 && (
                <IonIcon
                  className={easelWood > 0 ? "cursorP" : "op5"}
                  icon={easelWood === 1 ? trashOutline : removeCircle}
                  size="large"
                  color={easelWood > 0 ? "primary" : "var(--ion-color-light)"}
                  onClick={() => {
                    if (easelWood > 0) {
                      changeEaselWoodNumber(easelWood - 1);
                    }
                  }}
                />
              )}
            </IonCol>
            <IonCol className="ion-text-center f20 b" style={{ paddingTop: 7 }}>
              <IonLabel>{easelWood}</IonLabel>
            </IonCol>
            <IonCol className="ion-text-left">
              <IonIcon
                className={"cursorP"}
                color={"primary"}
                icon={addCircle}
                size="large"
                onClick={() => changeEaselWoodNumber(easelWood + 1)}
              />
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
      {disabled && (
        <div className="b f15 ion-text-center" style={{ marginBottom: 12 }}>
          <IonLabel>Trenutno nema na stanju</IonLabel>
        </div>
      )}
    </IonCard>
  );
};

export default EaselWood;
